import type { ComponentType } from 'react';
import type { ReactGadgetProps } from '@atlassian/jira-react-gadgets-common/src/types.tsx';
import { lazyForPaint, type PreloadPriority, type Cleanup } from '@atlassian/react-loosely-lazy';
import type { CustomReportGadgetData } from '../../common/types.tsx';

export const LazyCustomReportGadgetView = lazyForPaint<
	ComponentType<ReactGadgetProps<CustomReportGadgetData>>
>(() => import(/* webpackChunkName: "async-react-custom-report-gadget-view" */ './main'));

export const { preload }: { preload: (priority?: PreloadPriority) => Cleanup } =
	LazyCustomReportGadgetView;
